<template>
  <v-container fluid tag="section">
    <material-wizard
      v-model="tab"
      title="Executar Sequência Elétrica"
      subtitle="Selecione a versão da BDGD e CTMTS"
      :available-steps="tabsLiberadas"
      :tabs="tabs"
      class="mx-auto"
      :loading="loading"
      @click:next="next()"
      @click:prev="back()"
    >
      <sequenciamento-eletrico-wizard-tabs
        ref="sequenciamentoParametros"
        @step-observer="updateTabStatus($event)"
        @tipo-sequenciamento-changed="tipoSequenciamento = $event"
      />
    </material-wizard>
  </v-container>
</template>

<script>
  import SequenciamentoEletricoService from '@/services/SequenciamentoEletricoService';
  import wizardMixins from '@/mixins/wizardMixins';
  import routes from '@/store/modules/routes';

  export default {
    components: {
      SequenciamentoEletricoWizardTabs: () =>
        import('@/components/perdas-tecnicas/sequenciamento-eletrico/SequenciamentoEletricoWizardTabs'),
      MaterialWizard: () => import('@/components/base/MaterialWizard')
    },
    mixins: [wizardMixins],
    data() {
      return {
        tipoSequenciamento: 'COMPLETO',
        loading: false,
        tabs: ['Mês dos Dados', 'CTMTS', 'Confirmação']
      };
    },
    watch: {
      tipoSequenciamento(newValue) {
        this.tabs = this.buildTabs(newValue);
        this.tab = 0;

        const stepZeroComplete = this.tabsStatusAUX[0];
        this.tabsLiberadas = stepZeroComplete ? [0] : [];
        this.tabsStatusAUX = stepZeroComplete ? { 0: true } : {};
      }
    },
    methods: {
      buildTabs(tipoSequenciamento) {
        if (tipoSequenciamento === 'BT') {
          return ['Mês dos Dados', 'CTMT', 'UNTRMT', 'Confirmação'];
        }

        return ['Mês dos Dados', 'CTMTS', 'Confirmação'];
      },
      save() {
        const data = this.$refs.sequenciamentoParametros.exportData();

        this.loading = true;

        SequenciamentoEletricoService.save(data)
          .then(() => {
            this.$toast.success('Execução de sequenciamento elétrico salva com sucesso.', '', {
              position: 'topRight'
            });
            this.$router.replace({
              name: routes.state.appRoutes['SEQUENCIAMENTO_ELETRICO']
            });
          })
          .catch(() => {
            this.$toast.error('Erro ao salvar a execução de sequenciamento elétrico.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
